<template>
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
    :current-page.sync="currentPage" :page-sizes="[10,20,50,100,200]" :page-size="pageSize" :background="background"
    :hide-on-single-page="total<10" layout="total, sizes, prev, pager, next, jumper" :total="total">
  </el-pagination>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'yblPager',
  props: {
    total: {
      type: Number | String,
      default: 0
    },
    monitor: {
      type: Boolean, // 是否监听总数变化
      default: () => true
    },
    current: {
      type: Number,
      default: () => 1
    },
    size: {
      type: Number,
      default: () => 10
    },
    background: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      currentPage: this.current || 1,
      pageSize: this.size || 10,
      requestUrl: ''
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      'currentPageNum'
    ])
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.$emit('update:current', 1)
      this.invokeFatherMethod()
    },
    handleCurrentPageChange (val) {
      this.$emit('update:current', val)
      this.invokeFatherMethod()
    },
    invokeFatherMethod () {
      const item = {
        page: this.currentPage,
        size: this.pageSize
      }
      this.$emit('change', item)
      this.$emit('size-change', item)
    }

  },
  watch: {
    total: function (curVal, oldVal) {
      this.monitor && (this.currentPage = 1)
    },
    current: function (newVal, oldVal) {
      newVal && (this.currentPage = newVal)
    },
    currentPageNum: function (newVal) {
      const {currentPage, pageSize, url, type} = newVal || {}

      const maxPage = Math.ceil(this.total / pageSize)
      const dialogs = document.querySelectorAll('.el-dialog__wrapper:not(.dislog-box)')
      if (dialogs.length) {
        return
      }
      if (((type === 'skip' && [0].includes(+currentPage)) || (type === 'page' && [1].includes(+currentPage))) && +pageSize === this.pageSize && (this.requestUrl === url || (maxPage > 1 && this.currentPage === maxPage))) {
        this.$emit('update:current', 1)
      } else if ((type === 'page' && +currentPage > 1) || (type === 'skip' && +currentPage > 0)) {
        this.requestUrl = url
      }
    }
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue